import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Table, Button } from 'antd'
import { TableContainer } from 'components'
import ScanViewDataColumns from 'views/ScanSettings/components/ScanView/ScanViewDataColumns'
import ScanViewDetailsDataColumns from 'views/ScanSettings/components/ScanView/ScanViewDetailsDataColumns'
import ScanViewCompareDataColumns from 'views/ScanSettings/components/ScanView/ScanViewCompareDataColumns'
import ScanViewCompareDetailsDataColumns from 'views/ScanSettings/components/ScanView/ScanViewDetailsCompareDataColumns'
import { NoData } from 'components'
import axios from 'axios'
import { notificationToast } from 'components'
import {usePayment} from 'context/payment-context';


export const RECORD_STATUS = {
  COMPLETE: 'Complete',
  ERROR: 'Error'
}

const StyledTable = styled(Table)`
	min-width: 1200px;
`;

const BlackButton = styled(Button)(props => ({
  color: props.disabled ? 'black' : '#1794FF'
}))

const insertCustomColumns = (arr, index, newItem) => [...arr.slice(0, index), newItem, ...arr.slice(index)]

const ScanViewData = ({
  data = [],
  loading,
  setDetailsView,
  isDetailsView,
  customColumns,
  isScanCompare,
  scanSettingsId,
  recorderOnline = false,
  pageStats = {}
}) => {
  const {setPaymentModalOpen, isTrialAccount} = usePayment();
  const [currentPage, setCurrentPage] = useState(1)
  let columns = isDetailsView ? ScanViewDetailsDataColumns : ScanViewDataColumns

  const onCompareDetails = (scanSettingsId, record, setDetailsView) => {
    setDetailsView({
      document_a_id: record.document_a_id,
      document_b_id: record.document_b_id
    })
  }

  const requestShowElement = ({ entity }) => {
    axios
      .post('http://localhost:3001/show-element', {
        entity: entity,
        stats: pageStats
      })
      .then(response => {
        if (response.data && !response.data.success) {
          notificationToast({
            message: 'Error',
            description: `${response.data.error.message}`,
            icontype: 'alert'
          })
        }
      })
      .catch(error => {
        notificationToast({
          message: 'Error',
          description: `${error.message}`,
          icontype: 'alert'
        })
      })
  }

  if (isScanCompare) columns = ScanViewCompareDataColumns

  if (isScanCompare && isDetailsView) columns = ScanViewCompareDetailsDataColumns

	if(pageStats && pageStats.type){
		data = data.map((value, index) => {
			value.type = pageStats.type;

			return value;
		});
	}
	

  if (isDetailsView) {
    columns = insertCustomColumns(columns, 10, {
      dataIndex: 'visible',
      align: 'center',
      width: 250,
      render(visible, entity) {
	let selectorIsAvailaible = entity.selector && !entity.selector.includes('Selector not found')
  	let isComaptibleScanType = pageStats.type !== 'flow'
	
        if (recorderOnline) {
          return (
            visible &&
            isComaptibleScanType &&
            selectorIsAvailaible && (
              <Button data-id="showElement" type="link" icon="eye" onClick={() => requestShowElement({ entity })}>
                VIEW ERROR
              </Button>
            )
          )
        } else {
          return (
            visible &&
            isComaptibleScanType && (
                <BlackButton disabled={!isTrialAccount} data-id="showElement" type="link" icon="eye" onClick={() => {
                  isTrialAccount && setPaymentModalOpen(true, 'uRecorder');
                }}>
                    INSTALL URECORDER
                </BlackButton>
  	        )
          )
        }
      }
    })
  } else {
    columns = insertCustomColumns(columns, 10, {
      dataIndex: 'view_details',
      align: 'center',
      render(id, record) {
        let details = record.id
        let isValid = record && record.status !== RECORD_STATUS.ERROR
        if (!isScanCompare) {
          return (
            <>
              {
                isValid && record.notAllowed && isTrialAccount
                ?
                  <Button style={{color: 'gray'}} data-id="pageDetails" type="link" icon="eye" onClick={() => setPaymentModalOpen(true, 'page details')}>
                    PAGE DETAILS
                  </Button>
                :
                  <Button data-id="pageDetails" type="link" icon="eye" onClick={() => setDetailsView({ details })}>
                    PAGE DETAILS
                  </Button>
              }
            </>
          )
        } else {
          return (
            isValid && (
              <Button
                data-id="pageDetails"
                type="link"
                icon="eye"
                onClick={() => onCompareDetails(scanSettingsId, record, setDetailsView)}
              >
                PAGE DETAILS
              </Button>
            )
          )
        }
      }
    })
  }

  if (isDetailsView && customColumns && customColumns.details) {
    customColumns.details.forEach(col => {
      columns = insertCustomColumns(columns, col.position, col)
    })
  }

  // reset pagination when entering details view
  useEffect(() => {
    isDetailsView && setCurrentPage(1)
  }, [isDetailsView])

  return (
    <TableContainer>
      <StyledTable
        rowKey="id"
        pagination={{
          hideOnSinglePage: true,
          pageSize: 20,
          current: currentPage,
          onChange: page => setCurrentPage(page)
        }}
        columns={columns}
        dataSource={data}
        loading={loading}
        locale={{
          emptyText: <NoData />
        }}
      />
    </TableContainer>
  )
}

export default ScanViewData
